import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL, IDependentResponseDto } from '@/dtos';

export const QUERY_KEY = 'GET_DEPENDENT_NAMES';

export default (employeeId?: string) => {
  const { isLoading, data } = useQuery(
    [QUERY_KEY, employeeId],
    () =>
      api.get<IDependentResponseDto[]>(API_URL.V2_DEPENDENTS_EMPLOYEE_BY_EMPLOYEE_ID(employeeId || ''), {
        params: {
          employee_id: employeeId,
        },
      }),
    {
      cacheTime: 0,
      enabled: !!employeeId,
    }
  );
  const formatedData = useMemo(() => {
    const list = data?.data || [];

    return list.map((item) => ({
      id: _.toString(item.dependent_id),
      fullName: `${item.first_name || ''} ${item.last_name || ''}`.trim(),
      relationshipType: item?.relationship_type as string,
    }));
  }, [data]);

  return {
    isLoading,
    data: formatedData,
  };
};
